module.exports = __webpack_public_path__ + "static/media/af.339e1311.svg";